module.exports = __webpack_public_path__ + "img/Logo_Luxgen.8e9d1e22.svg";